import api from '../../lib/commons/api'
import { VersionReportTemplateRepository } from '../../applications/ports/versionReportTemplateRepository'
import { useCallback } from 'react'
import { VersionReportTemplateEntity } from '../../domain/entity/version-report/VersionReportTemplateEntity'

type VersionReportTemplateResponse = {
  uuid: string
  name: string
  updatedAt: number
  updatedBy: string
}

const convertResponseToEntity = (
  response: VersionReportTemplateResponse
): VersionReportTemplateEntity => {
  return {
    uuid: response.uuid,
    name: response.name,
    updatedAt: new Date(response.updatedAt),
    updatedBy: response.updatedBy,
  }
}

export const useVersionReportTemplateRepository =
  (): VersionReportTemplateRepository => {
    const fetchAll = useCallback(async () => {
      const response = await api.functional.request(
        'GET',
        '/api/v1/projects/version-report/template/list'
      )
      const templates: VersionReportTemplateResponse[] = response.json
      return templates.map(convertResponseToEntity)
    }, [])

    const create = useCallback(
      async (name: string): Promise<{ uuid: string }> => {
        const request = { name }
        const response = await api.functional.request(
          'POST',
          '/api/v1/projects/version-report/template',
          request
        )
        return response.json
      },
      []
    )
    const update = useCallback(
      async (uuid: string, name: string): Promise<void> => {
        const request = { uuid, name }
        await api.functional.request(
          'PUT',
          `/api/v1/projects/version-report/template/update`,
          request
        )
      },
      []
    )
    return {
      fetchAll,
      create,
      update,
    }
  }
